import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../core/security/authentication-service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {

  constructor(public router: Router, 
              public authService: AuthenticationService) {} // Injete o serviço de autenticação

  redirectToRoot(): void {
    this.router.navigate(['/obrigacoes-acessorias']);
  }

  loginOrLogout(): void {
    if (this.authService.isLoggedIn()) {
      this.authService.logout();
    }
    this.router.navigate(['/login']);
  }
  
  obterUsuario(): string | null {
    return this.authService.getUsuarioSessao();
  }


}
